export default __webpack_public_path__ + "static/media/checkout_success_icon.39666179.svg";